import React from 'react'
import { Link } from 'react-router-dom'
import JsonLd from './JsonLd'

const normalizePath = (url) => {
	if (!url || url === '/') return '/'
	if (/^https?:\/\//i.test(url)) return url
	const prefixed = url.startsWith('/') ? url : `/${url}`
	return prefixed.endsWith('/') ? prefixed : `${prefixed}/`
}

const toAbsoluteUrl = (url) => {
	const baseUrl = 'https://www.switchboardfree.co.uk'
	const normalized = normalizePath(url)
	return /^https?:\/\//i.test(normalized) ? normalized : `${baseUrl}${normalized}`
}

const getSchema = (items) => {
	return {
		'@context': 'https://schema.org',
		'@type': 'BreadcrumbList',
		itemListElement: items.map((item, index) => ({
			'@type': 'ListItem',
			position: index + 1,
			name: item.label,
			item: toAbsoluteUrl(item.url)
		}))
	}
}

const PageBreadcrumbs = ({ items = [], inHero = false }) => {
	const currentPath = (typeof window !== 'undefined' && window.location && window.location.pathname)
		? window.location.pathname
		: '/'

	const finalItems = items
		.filter(item => item && item.label)
		.map((item, index, arr) => {
			const isLast = index === arr.length - 1
			const itemUrl = item.url || item.href || (isLast ? currentPath : null)
			if (!itemUrl) {
				return null
			}

			return { label: item.label, url: normalizePath(itemUrl) }
		})
		.filter(Boolean)
	const lastItemIndex = finalItems.length - 1

	if (finalItems.length < 2) {
		return null
	}

	const nav = (
		<nav aria-label="Breadcrumb" className={`page-breadcrumbs ${inHero ? 'page-breadcrumbs--hero' : 'page-breadcrumbs--default'}`}>
			<ol
				className="unstyled mb-0 page-breadcrumbs__list"
			>
				{finalItems.map((item, index) => (
					<li
						className={`d-inline-flex align-items-center page-breadcrumbs__item ${index === lastItemIndex ? 'is-current' : ''}`}
						key={`${item.url}-${index}`}
					>
						{index > 0 && <span className="pl-5 pr-5 page-breadcrumbs__separator">/</span>}
						{index === lastItemIndex
							? <span className="page-breadcrumbs__current">{item.label}</span>
							: <Link to={item.url} className="page-breadcrumbs__link">{item.label}</Link>}
					</li>
				))}
			</ol>
		</nav>
	)

	if (inHero) {
		return (
			<>
				<JsonLd data={getSchema(finalItems)} />
				{nav}
			</>
		)
	}

	return (
		<>
			<JsonLd data={getSchema(finalItems)} />
			<div className="full-width bg-light bb-1 p-0 pt-20">
				<div className="container">
					{nav}
				</div>
			</div>
		</>
	)
}

export default PageBreadcrumbs
